import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import RoomOffer from './RoomOffer';
import RoomOfferSandamiano from './RoomOfferSandamiano';
import { getRoomOfferByRoomTypeId, getNoOfSelectedRooms, isWithoutAccommodation } from '../../apiHelpers';
import { SANDAMIANO_HOTEL_ID } from '../../utils';
import T from '../Translate';


class SelectedRooms extends Component {

	render() {
		const { formValues, hotelId, roomOffers } = this.props;

		return (
			<div>
				<fieldset className="fieldset">
					<legend>
						{isWithoutAccommodation(formValues)
							? <T id="SelectedRooms.index.title.withoutAccommodation" />
							: <T id="SelectedRooms.index.title" data={{ count: getNoOfSelectedRooms(formValues) }} />
						}
					</legend>
				</fieldset>

				<div className="rooms">
					<div className="room-offers">
						{hotelId === SANDAMIANO_HOTEL_ID &&
						<RoomOfferSandamiano/>
						}

						{hotelId !== SANDAMIANO_HOTEL_ID &&
						/* Projdeme vybrané typy pokojů */
						Object.entries(formValues.rooms).map(([roomTypeId, rooms], roomTypeIndex) => {
							// A pro každý typ pokoje počet konkrétních pokojů
							return rooms.map((room, roomIndex) => (
								<RoomOffer
									key={`${roomTypeId}-${roomIndex}`}
									roomOffer={getRoomOfferByRoomTypeId(roomTypeId, roomOffers)}
									roomIndex={roomIndex}
									isLast={
										Object.keys(formValues.rooms).length - 1 === roomTypeIndex &&
										formValues.rooms[roomTypeId].length - 1 === roomIndex
									}
								/>
							));
						})}
					</div>
				</div>
			</div>
		);
	}
}


export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		hotelId: state.app.hotelId,
		roomOffers: state.app.roomOffers,
	})),
)(SelectedRooms)


// WEBPACK FOOTER //
// ./src/components/SelectedRooms/index.jsx